export default __webpack_public_path__ + "static/media/ISSO SYLLABUS 2027-26 CLASS 10.3d5424af.pdf";